import { serializeError } from 'serialize-error';
export class Feil {
	constructor(melding, statuskode = undefined) {
		this.melding = melding;
		this.verdier = {};
		this.statuskode = statuskode;
	}
	med(felt, verdi) {
		if (verdi instanceof Error) {
			verdi = serializeError(verdi); // Error-objekter i JS serialiseres ikke som andre objekter med JSON.stringify
		}
		this.verdier[felt] =
			typeof verdi === 'string' || verdi instanceof Feil
				? verdi
				: JSON.stringify(verdi);
		return this;
	}
	toString() {
		return (
			this.melding +
			Object.keys(this.verdier)
				.map(
					(felt) =>
						' ' + felt + '=' + JSON.stringify(this.verdier[felt])
				)
				.join('')
		);
	}
}
